import React from "react";
import classNames from "classnames";
import layout from "../../layout/OnboardingLayout.module.scss";

export const FreshbooksSidebar: React.FC = () => (
    <div className={classNames(layout.freshbooksSidebar, layout.fadeIn1)}></div>
);
